<h1 class="text-3xl font-medium title-font text-center mt-8 mb-6">Stundenplan</h1>
<div class="mt-10 mb-10 md:m-10 overflow-x-scroll">
  <app-timetable></app-timetable>
</div>

<h2 class="text-3xl md:text-4xl font-medium title-font mt-24 mb-6 text-center">Klassenüberblick</h2>
<div class="mb-20 flex flex-wrap justify-center">
  <app-activity-card [activityCard]="activityBjjGi"></app-activity-card>
  <app-activity-card [activityCard]="activityBjjNoGi"></app-activity-card>
  <app-activity-card [activityCard]="activityBjjKids"></app-activity-card>
  <app-activity-card [activityCard]="activityBjjWomen"></app-activity-card>
  <app-activity-card [activityCard]="activityBjjDrills"></app-activity-card>
  <app-activity-card [activityCard]="activityBjjSparring"></app-activity-card>
  <app-activity-card [activityCard]="activityOpenMat"></app-activity-card>
</div>
